/* The shelf's header, labels and detail (see shelf.tsx), over its 3D view on the canvas. */

.shelf {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 5;
}

.head {
  top: 16px;
  left: 16px;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 8px 10px 8px 16px;
  pointer-events: auto;
}

.name {
  font-size: 16px;
  font-weight: 700;
}

.tags {
  position: absolute;
  inset: 0;
  overflow: hidden;
}

/* A museum label on the shelf's front edge. */
.tag {
  position: absolute;
  display: flex;
  flex-direction: column;
  transform: translate(-50%, 0);
  padding: 3px 9px 4px;
  border: 1px solid #d8b894;
  border-radius: 3px;
  background: #fffaf3;
  box-shadow: 0 2px 6px rgba(90, 58, 46, 0.18);
  font-size: 11px;
  line-height: 1.5;
  white-space: nowrap;
}

.empty {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  padding: 14px 20px;
  border-radius: 14px;
  background: var(--panel);
  font-size: 14px;
  text-align: center;
}

.detail {
  top: 16px;
  right: 16px;
  bottom: 16px;
  width: min(420px, 44vw);
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 16px 16px;
  overflow-y: auto;
  pointer-events: auto;
  animation: rise-in 0.3s ease-out;
}

@keyframes rise-in {
  0% {
    opacity: 0;
    transform: translateY(10px) scale(0.96);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}

.title {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
}

.date {
  margin: -6px 0 0;
  font-size: 12px;
  color: var(--ink-soft);
}

/* In place of the letter, for a piece kneaded freely. */
.note {
  margin: 0;
  padding: 10px 12px;
  border-radius: 10px;
  background: rgba(95, 183, 162, 0.12);
  font-size: 13px;
}

.photo {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(90, 58, 46, 0.15);
}

.actions button {
  flex: 1;
}

/* Below: the piece as a 3D model, and taking it off the shelf (asked once more before it
   goes). */
.links {
  display: flex;
  justify-content: center;
  gap: 16px;
}

.link {
  border: none;
  background: none;
  padding: 2px 6px;
  font: inherit;
  font-size: 12px;
  color: var(--ink-soft);
  text-decoration: underline;
  cursor: pointer;
}

.link:disabled {
  opacity: 0.5;
  cursor: default;
}

.remove {
  padding: 10px 12px 12px;
  border: 1px solid rgba(201, 92, 80, 0.35);
  border-radius: 10px;
  background: #fff4f1;
}

.remove p {
  margin: 0 0 8px;
  font-size: 12px;
  line-height: 1.6;
}

.danger {
  border: none;
  border-radius: 10px;
  padding: 8px 0 7px;
  background: #d9695f;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 3px 0 #b04f47;
  transition: transform 0.1s, box-shadow 0.1s;
}

.danger:active {
  transform: translateY(2px);
  box-shadow: 0 1px 0 #b04f47;
}

.danger:disabled {
  opacity: 0.5;
  cursor: default;
}

/* A piece picked up: turned by dragging, its kneading on a slider. */
.inspect {
  left: 50%;
  bottom: 16px;
  transform: translateX(-50%);
  width: min(520px, calc(100vw - 32px));
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 14px 12px;
  pointer-events: auto;
}

.hint {
  margin: 0;
  font-size: 12px;
  color: var(--ink-soft);
  text-align: center;
}

.timeline {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 10px;
  background: var(--accent-soft);
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.timeline span {
  color: var(--accent);
}

.timeline span:last-child {
  min-width: 3.5em;
  text-align: right;
}

.timeline input {
  flex: 1;
  min-width: 0;
  accent-color: var(--accent);
}

@media (max-width: 640px) {
  .tag {
    padding: 2px 5px 3px;
    font-size: 8px;
  }
}

/* Tall screens: the detail comes up from the bottom, under the turning piece. */
@media (max-aspect-ratio: 1/1) {
  .detail {
    top: auto;
    left: 10px;
    right: 10px;
    bottom: 10px;
    width: auto;
    max-height: 52dvh;
  }
}
